export const proyectUrl = () => {
  if (process.env.REACT_APP_PADDLE_ENVIRONMENT !== 'prod') {
    return 'https://1d7dadc823.nxcli.net';
  }
  return 'https://360ra.com/';
};
